<p-messages
  *ngIf="!filtersArray.length"
  [(value)]="noFiltersAddedMsg"
  [enableService]="false"
  [closable]="false"
/>
<div
  class="tw-pt-4"
  *ngFor="let arr of filtersArray; let i = index; let isLastBlock = last; trackBy: trackByFiltersArray"
>
  <div
    class="tw-flex tw-items-center tw-p-4 tw-gap-4 tw-my-[-15px] tw-bg-gray-100"
    [ngClass]="{ 'tw-mb-5': isLastFilter && isLastBlock }"
    *ngFor="
      let filter of arr.expressions;
      let j = index;
      let isLastFilter = last;
      trackBy: trackByFiltersExpressions.bind(this, i)
    "
  >
    <p-dropdown
      styleClass="tw-w-72"
      filterBy="label"
      [filter]="true"
      [ngModel]="findFilterSource(filter).name"
      [options]="filterSourceOptions"
      [disabled]="readonly"
      class="ng-dirty ng-invalid"
      [ngClass]="{ 'ng-dirty ng-invalid': filterSourceWarnings[i][j] }"
      (onChange)="changeFilterSource($event.value, i, j, true)"
    >
      <ng-template
        pTemplate="selectedItem"
        *ngIf="filterSourceWarnings[i][j]"
      >
        <div class="tw-flex tw-items-center tw-gap-2">
          <div>
            <span
              class="fa-solid fa-circle-question"
              pTooltip="This metric is not compatible with one or more selected dimensions."
              tooltipPosition="left"
            ></span>
          </div>
          <div>{{ filter.metric.displayName }}</div>
        </div>
      </ng-template>
    </p-dropdown>

    <p-dropdown
      styleClass="tw-w-72"
      [disabled]="readonly || !options.showMultipleOptions"
      [ngModel]="findMetricFilterOption(filter.type)"
      [options]="filterOptions"
      (onChange)="changeFilterType($event.value, i, j, true)"
    >
      <ng-template
        let-option
        pTemplate="selectedItem"
      >
        {{ option.displayName }}
      </ng-template>
      <ng-template
        let-option
        pTemplate="item"
      >
        {{ option.displayName }}
      </ng-template>
    </p-dropdown>
    <p-iconField iconPosition="right">
      <p-inputIcon>
        <i
          *ngIf="
            isPercentFormat(filter) && metricFilterSelection[i][j] !== 'na' && metricFilterSelection[i][j] !== 'not_na'
          "
          class="fa-solid fa-percent tw-leading-4 tw-align-middle tw-mb-3"
        ></i>
      </p-inputIcon>
      <p-inputNumber
        #filterValueInput="ngModel"
        *ngIf="metricFilterSelection[i][j] !== 'na' && metricFilterSelection[i][j] !== 'not_na'"
        [ngClass]="{ 'ng-invalid ng-dirty': emptyFilterWarnings[i][j] && !filter.value && filterValueInput.touched }"
        placeholder="Value..."
        mode="decimal"
        minFractionDigits="0"
        maxFractionDigits="5"
        [useGrouping]="false"
        [disabled]="readonly"
        [ngModel]="formatValue(filter)"
        (ngModelChange)="setFilterValue($event, filter, i, j)"
      ></p-inputNumber>
    </p-iconField>
    <div class="tw-flex tw-items-center tw-w-full tw-justify-between">
      <p-button
        *ngIf="!readonly && options.showOrFilters"
        label="OR"
        severity="secondary"
        [icon]="isLastFilter ? 'fa-solid fa-plus' : ''"
        (onClick)="addFilter(i, j)"
        [disabled]="!isLastFilter"
      ></p-button>

      <p-button
        *ngIf="!readonly && options.showOrFilters"
        icon="fa-solid fa-xmark"
        class="tw-text-lg"
        severity="secondary"
        [rounded]="true"
        (onClick)="removeFilter(i, j)"
      ></p-button>
    </div>
  </div>
  <div
    class="tw-mt-8 tw-mb-4"
    *ngIf="!isLastBlock"
  >
    <p-button
      label="AND"
      severity="secondary"
      disabled="true"
    ></p-button>
  </div>
</div>
<p-button
  *ngIf="!readonly"
  icon="fa-solid fa-plus"
  class="tw-text-lg"
  severity="secondary"
  [rounded]="true"
  (onClick)="addBlock()"
></p-button>
